import { UploadProgressContent } from './NubsUpload.style'

const UploadProgress = (props) => {
    const { 
        progress, 
        // minimum file size to display the upload progress on.
        // Default: 1 Mb
        minSize = 1000000 
    } = props
    const getDisplaySize = (size = 0) => {
        return `${(size/minSize).toFixed(2)}Mb`
    }
    return progress?.total > minSize && progress?.loaded < progress?.total
        ? (
            <UploadProgressContent>
                <span>Uploading {progress?.fileName}:</span>
                <span>{getDisplaySize(progress?.loaded)} of {getDisplaySize(progress?.total)}</span>
            </UploadProgressContent>
        )
        : null
}

export default UploadProgress